<script setup lang="ts">
import { useCustomizerStore } from '../stores/customizer';
const customizer = useCustomizerStore();
</script>

<template>
    <div :class="customizer.preloader == true ? 'show-preloader' : 'hide-preloader'" class="preloader">
        <div class="d-flex flex-column justify-center align-center h-100">
            <!-- <div class="pageloader"></div> -->

            <div class="loader-wrapper">
                <svg
                    class="pulse"
                    width="170"
                    height="169"
                    viewBox="0 0 170 169"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <rect width="170" height="169" fill="url(#pattern0_25_3388)" />
                    <defs>
                        <pattern id="pattern0_25_3388" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_25_3388" transform="matrix(0.00478469 0 0 0.00499272 0 -0.00676097)" />
                        </pattern>
                        <image
                            id="image0_25_3388"
                            width="209"
                            height="203"
                            preserveAspectRatio="none"
                            xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANEAAADLCAYAAADwd3YSAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAA0aADAAQAAAABAAAAywAAAACqHFrlAAAWxUlEQVR4Ae2debAV1Z3HD1OCVID3IOjIEkQMhi1kNCqo5K+MpiIgIokzaqlJqhytyYipcsqAhijLYxGEp+JgZiaksmES2R88cOKMVE1BGYmjTgzyVp1hX0QW2SJO7vSvu093v3t7OafvObe3b1e9191nP9/f73PP6XP7djOGDQpAASgABaAAFIACUAAKQAEoAAWgABSAAlAACkABKAAFoAAUgAJQAApAASgABaAAFIACUAAKQAEoAAWgQLEU6Fas7qa7t3v3ny/teOMkO3DoT2z7zo/Y8RMXWGv7WafRJVZirGSZbMjgi9nnBvdknxvwGTZ2dC9207h6NmZkb9jTUat2BxC9dlr71rSr5XRp1ZpDbNv2Y2zPvj85aUolA5iyzQuRQRMhZW32QX2fHmzctXVs4i392cSbL2H1dd1hX66Rxj1E1ihuUNEnT10ovbzhCPvJS/vYXhscBwg7UxyIvGX0NYC65av92Izpw9iQwT1h5yBjKAiHuApEFC2C4Fn5y4Psn3+6j50596mVzfZ8LwAUUS1E3jL+ZuoAwGSpreU/INIia2Whv153uPTUok529tz/eSdiNCszN50Q8dY8cO8QNuORoZjmcUEU7QGRIiGDiqHR54HvtbDfvXnCSeK5mqkpRNSAPr0uYj9fMZZNGN8XtncsUt0BhKxOv9DcO944Ufr7f2xhJ05dMKZnbtIkIaJWUFv+7r4hbMGs4bC/a5bYRxAxtnThGdc0HS49OqvNSZQ2iKhh46+tZ6t+NBbTO8dK8Q4AUTzdQnMZ8JQMiLqkSSNENJf84qg+bMPPrwZIXawld/IXcsmROkoBP4Ci8iQZ/8fdH7Op97/D6NotyXZkuW5ApNB6BNDashFIYfHainoXIFWlLSCqSj43swnQpiNuQMaOCKSHZ7RmrNXpaC4gUmCHrAPEJdj6H0fYkuX/i2kdF0Rwj4UFQaGCklUAZKwg+HlhWhcWqF9Oe+2Djb/4Mr5HCjK4TzhGIh9RRIMqABLNmPJ03/3+e1hokLARIJIQy5s0rwBRH/cdPMf+5WcHvN3FcYgCmM6FiBMURQCt23yky10ITtocTOf4hPSdbRNwB7hj2OADjETB2vjGcIB8I3MW+PTyD3LWIz3dAUQSuhYJIJLlpbUHGP3aVkKiQiYFRIJmJ4DWbz4qmDo/yVatPpifzmjqCSASELaoAJE0v1oPiKJcBBBFKFRkgEiavQfOsebffogpXYifAKIQcUyAmrN7K09I16Sidux0f1AolbEgiQFRgKEBkCtM86v4IHHVqDwCRJWaMAJoQ3PxFhF8pDCDaEqHVbogdRgDRGXaAKAyQezTP+w67R+BUEDk9QEA5FWj6/G7733cNQBnjgIYiWwpvj+7HVM4xy0qD/YdOl8ZiBBTAUBkyEAArW3CNVAYE/+z51xYdKHjCg8RACq0/yvpfKEhAkDiPrS79Yx44oKlLCxEAEjO04+f+kQuQ4FSFxIiAmgdroEK5OZ6u1o4iABQPIe66fp+8TIWIFehIDIB2oRVuAL4dU27WBiIAFBN/apQlRUCIgugDwtlWNWd/co4TOeCNM09RATQ+k0AKMgBRMOHXt5TNGnh0uUaIgCkzp+/NLqPusJyVlJuIQJA6jy1X10PNmZkbzxeLUDSXEJkArT5WECXESyrwE24HgqVLHcQEUAbNuMaKNTqkpETb+kvmaNYyXMFEQDS47wTb75ET8E5KTU3EAEgPR55zzcG4VWUEdLmAiIAFGHlKqLvvmNgFbmLkTXzEJkANWMRQYe70v1yE8b3xapchLiZhogA2giAIkwcP/rx710ZP3OBcmYWIgCk10tvvA6jkKjCmYQIAImaN366F5eMjp+5YDkzBxEA0u+hM6cPx8u9JGS+SCJt4kkJoKbmjxJvR54bcMN1fdlj04cqWUzY8caJUlvnWXb8xKfs9d+fDJXtxuvr2aABFxvwXpy5xQwlYoWqoyjSBGiLsQpX6ma87brrSwrMM+/ruY06S8zomifMymHn67pzWljypKdApx6jTr45YRRvl8PjzL0RGBDsJOuSQrAtlNnM57TFU4pEGWY5TgOtA35a37s7e2vbDbG/F9rVcrq0861TbMurx9ibb58y+8tb6dWqQmejATwdiUftGX9dHbv1q5eyr/91/9SPiq53mF1O5z8HIGoeILKN5Lid5XUkjR3Dd+XO6oY7R+YB5SOAmlZdI32j6clTF4z31x5l64yfm+xqsZ6SarbMhp23UhYip4VGxhFXfYY9dP/l7K5pl6XSX1PZKC4g7S2AaApnuwggsuXh7umRxo7hOxmIfrb8S2zS1y4R9geCZ+UvD7KfvnSAnTn7Z7NKXp9qiHh/+vTqzh64bzB78FvpuotCWDTekVruCaBNWz6y8QFEXuekDxVn5OHSlBmHO3VZsGcaamV8fuEodve0gcK+sGzFnhLBc9aAx2mDUQmvz9tO3spqRiLefl5GnTFqzp45TKrNvAwde2HhdFQeViYHiNJYhuKegmsiSzfuno5AXRza1I17nZXB+e8Gl5gMQHTNM3PO+2x3m/2GCMMkSUDEe37TuL7sufkjE79mSiVEXoBMZzDND4i8n/AqRqLnF44U/jSn0efFlfttS3BbJAsREVzfp0fio1LqIDIB2mqtwvGPTstk3HAYiSxd+Oexccal4YLZez69Kgs2p3OiANG1z2NPdrJt241XTtpDmFOzUa9dtVkFr88LO0/rjn5UjDeXVSxPRwV6Y71peTa/tHfefhl7YdGoRPw5kUrLjcrPHYAowFnK5aLa0mJhwZbLcSUuUBfnMyXkXmfn4LvnFoiNQATQvQ/tZq3tZ4yyDVexy3NqDnB4M17h6hxvN++OX/0E27gv17NVPxobe4me1yO7T80dCwTQ5q34IlXWgLLp4wAkW0dS6Xe+dZJNvf8dRvDXsg2pgAgA1cbk0gB1nK1NwxTWYix+1BykxCECQAo9KKQoWYDaMggQ7z6B9PCMVn6qfZ8oRE80dGAKp93EjBUJIC7nK68dZeRf/FznPjGIqIMbN+MaSKdxqWxZgNo78vNayX/9xR7W/NsPtYOUCEQASDc6VvnSABl3XOdte+Tx3doXGmoOEQCqjZs+O3+E0BeptJL17X9oYe2d+RmBvAqfPH1B+/VRTSECQF7z6juWBailNX8jkFfdra8dYfTbJm+YyuOaQQSAVJotuCxpgNqK8ULjhc+9HyxalTE1gQgAVWklwewAKFio3715QttopB0iAqip+Xhw7xCjRIFGyWug1rZ8T+H8RNU1GmmFCAD5mVJ9GAAS0/T1N48bv749rfzaSBtEAEjMsNWmamyQW4Vra8/nKpyojqvWHBJNKpxOC0QASFj/qhICIHn5ml89Ip8pIodyiABQhOKKohsbxH7Szb8HKvoIxGXfe+Cc8imdUogIoE1bsIjADaZr39gwUujJNwDI3wKbXjnqHxEzVBlEACimBSSzyQLU3nFesob8J9++U+0HvRKIAFBtHK9x3iipEQgA+dtld6vaL5irhggA+RtKdeiyeXJTOAAUbIHjpz5RelNqVRABoGBDqYyRBaijE1O4KP3/uFvdaBQbIgJoMxYRomxVdTwAqlpC3wJOnPzUNzxOYCyIAFAcqeXzACB5zURzvPue9dxw0fRh6aQhAkBhcqqLkwWoE1M4deJLliQF0Rv/dRJTOEmB4yRfOneE0CoclU0/qANAcVRWl0cKovHX1nebO+sKdbWjpAoFZACizN+6e0BFGQiorQJSEFHTpk68FCBpspEsQLCHJkNIFisNEQwnqbBg8jgA8aLxwcaVEN/3/2wP8cQRKWNBRGXCcBHKSkQ/I3ENFFQs2WMeptpB8lSEjx7RqyIsbkBsiKhCGC6u7G4+FQDx0mAPrkT0vm+9und+VwURNRWGizZYUIpn5oivwgWVUR4Oe5Qr4n8+ZmRvZW9EqRoiaiIM52+osFAdAPH6yB4NP7yCn2JfpsBfjakrC6nuVAlE1ASAJG4InQDxVgAkrkTl/sbr+lUGVhGiDCJqA0CKtsSSOV8Q/iI1urTwFADJX58JxrteVW5KIaKGwXDB5qklQLwVZI/5Tw7jp9gbCnzlhnqlOiiHiFoHkCptlARAvBUAiSvB2KSbL1P+OkotEFGTAZJruMWzazeFc2vtegSQLD0m3tK/qzAKzrRBRG0DSIwta0geIO4nRQepb58eQm/K4HqJ7pWtlYdVuGHL0dIP5n7gm8T7inVK4L4Z2m2a9chK+8GVGXp7OAH0zSmXuR3xVaAy8N9eO1ba1XKGvf77k2zfwbPs0OELhjBWMaTP9dfUs3713dmN4+qMN2bXMdnvPMgeT8x5v4vWjsYefc0w543hRv3OMbcF2cvduC2Tenu42xLeVMebzIbOmP559tj0odL28Jbrd6y8QL9KKCwIJC48z+d023YaCncMbJ50c41vZ/Ia2w4y0rhGN7OZEa7x3TCeg4T3ugTVy9O7MjlhRray5FZBRiDlkgWIXv2xcetR9sq/H2Nnzv65S1vMEj0QUUXeugcN7M4evH8Imzb5UuH5Ptnj8TmddptJU7NUo2BXXzPMrsirp6OBkcDKZxfjpKUISzOe1tveCp3NcuySzGOrPLNFnoz8kJdJldu5uuhl5TP/O/H1vbuzt7bdIKyP24LoI9c7otNWncIPpApBebczDNFSiRGIng09++kP2Nv//THvuamzV5coiCgDpe9b1519+55B7NHvXi5kVwckExyzFNP5uZOaDmp7btYhmvGwnlGIVBMSmxKq2spB8joL1cENyD/JrDD3v/eTkkJp8xrbCqEwo2v8o4un4W5qf3zxTzEnjyc9hfm3xc1VltwsZum8q4SncMtW7CmtWLnPqt4o1i2Zmu6eiUJkFcTY4EE92I+fHSM0zTNBmk1TO9qoEfkbiQYP6Mn+c9P1WkYhUk3rwgJVUL7l+eJWFCB6Mumd33m39OLK/eXyKDnff+AT9vU732a/XnfYJTGgZLLHwtlXBsTmI3jF4tHaACKFag4RVZpHkGQAuveh3eydP5wmKbRujz3Vxh6Z2SYE0qKcgvTgfZezCeP7ap1xJQIReU6eQJIFqKW9di/YWtd8SBikhlnDtEJd68K/OKoPm/HIUO3VJgYR9YxAWvBUtqcSsgC1tqt7aKCod4iCRMvxebn7u673ReyFRaO0TuO4/olClHWQsgAQN7QMSPN/mO0RqU+vi1jTqmuEFla4PtXsE4coqyA9M1dsFY4WEegaKIkRqNwx1m0Wm9rRiJRlkBp+MLxmAJHGqYAoayBJA9RRu2ugcnDKz9dKgLQggyPScwtGarm1p1xH73lqIKJGmcutT33e277UHcsC1JYigLiYUiA9eSXPlvp9EgCRKKmCiBqUZpCWzB0u9EUqn8KlESDSmLa1mw4KrdrR1G5BBkBKCiDSMnUQUaNMkFL2vUWeACKNaVsjAdLCJ9O72PDsfLE3qFu9Vv8/lRBRN9MEkixA7R3Zec29FEgp/DoiaYDIV1MLUVpAWjJHbhWuvTM9iwikociWVZAaEx6BuLaphogaSSNSUrekyABEb2do78zOCMQdgO9XbzogfI20KAWLP40NyU7huG60Tz1E1EgCqda3pCyeI76IQAC1tGZvBCJtvdvqJvHFhiRBShNApF8mIKKGmrek1OjeLmmA2mp/Kw9pomNb3SQxIs2u/dcRjQ21/x4oSufMQEQdqcW9XUUGiDvLyxIgPV1DkAigu6bJ/9ye90vXPlMQkQg6b0mRBai1LftTuCDHShtIoq/fDOqPzvDMQURi6ACJPlGp3Cix6YtUugbKM0Bcg5c3HmAPz9wd+Xsk0k3niJRmgEirTEJEDVcJEgAiRf231RsPC4NEI7nqLe0AUX8zCxE1XgVIsgC1tWd3GZs0i7MlBVI1bw+M08+4eTINEXWaQIp7tzEAEncbGZDo+7Vqt6wARP3MPETUCRMkyZskF0leAxVxBCJtvdvLGw4JT+3oVqm4W5YAoj7mAiLqiAxIAIgUi7fpBknl6zfj9VA+V24goq6LgETftFO6KKn4Klx7x/mopIWLlwGJfn8lutXi5WeibZFJlyuIqONhIAEgGdcIT6sapKwCRCrlDiLqFIFU/vuXRcZt/BiBSB1122/Wi18j0UNdgrYk390U1CaZ8FxCRAKYINm/f1kIgGR8Qirtb9YfFF5s8AMpDe9ukuqwT+LIawOfPJkK2rv/fGnI4J6R/eTXQB2d572P8Db76n0uNgV4z73P67a+2jf+e55nbaa3MtF/c/M+J9zNbz4JmyeprMMokzae3vOobiu8LICf8vR2Zvd530YC760I5plZhyecumJmtP55+00hVh1Wir+9YyA95y1S5zVNh0uPzmozC5R9c4bVivT9j+x0+pqsvkVegKh07oC8pkrncV3LcTkTHDO3UYD7UHg7pEuheYSIFLlLAiTSRWR6TenSvhUeonKAyGCAyHZbgwz344J08Z5xnaww87/x765pYiNS2sGQaV9ur4lEROAAdRpTOGxqFPjVOrGbVtXUlo5SCgsRANLngEUDqbAQrdt8lGEE0gfSS2uLMyIVFqLv3DOo2+SJ/fR5EUpmBNITDR1dL6RyqEthISJbLpg1HCBpduqxo3tpriH54gsNEckPkPQ54T89PbrmD5fX15vgkgsPEUlDIN2GqV2wl8SIKQpAJA0gsh0EIMUgJSDLC4uKMQLx7gMiroSxB0geMWIeFg0gkgkQlTkLgTRlElbtymQROl1uvCP17mkDC3cXDCDycQ+A5CNKRNDyhcUEiGQBRAHOAZAChPEJfr7AAJEcgMjHKXgQQOJKBO+LDhApA4iC/cOMIZBun/zZiFTFjH5+YfoeLp+EJQCRgOoAqVKkJN+RWtmaZEMAkaD+AMkVCgC5WtARIOqqR+gZQGIMAFW6CCCq1CQ0hECafGsxr5EAkL9rACJ/XUJDF8++qnAgpeEt3aFGSTASEMUUv0ggAaBwJwFE4fqExhJIt93aPzRN1iMBULQFAVG0RqEp8gxS4/z0vOY+1AgJRwIiBQYwQZqYr8WGtL3mXoGZtBUBiBRJSyBNyQlIAEjOKQCRnF6hqS2Qsn2N1NhQ3LuxQ40bEgmIQsSJE2WCNCmbU7vGhpHGE0yj390UR5c85wFEGqxLIN0+KVsjUuO8UQAopi8AopjCRWXLEkhZeM19lN5JxgMijepnASQAVL0DAKLqNQwtgUCamtKpHQAKNZ1wJCASlip+QhOkyZfEL0BDzqXzsIigSlZApErJiHLSBNLSuSOwiBBhL5loQCSjVpVp0wASAKrSiD7ZAZGPKDqDCKQ7Jiez/P0MRiAtpgVEWmQNL9QE6bbaXiM9MwdTuHCrxI8FRPG1qypnLUECQFWZKjIzIIqUSF8CAmnabZfqq8AoGQBpldcsHBDp1zi0Bp0gLZnzBazChaqvJhIQqdGxqlJMkKaoHZEAUFUmkcoMiKTk0peYQPqGIpAWz8YIpM9SlSUDokpNEgtRAdKyBgBUawMColorHlFfNSARQN+cgt8DRUisPBoQKZe0+gIJpKmT5K6RAFD1usctARDFVU5zPgMKYZCWzrsKI5Bme4QVD4jC1Ek4TgQkAJSwkYzqAVHyNghtAYF0x6S/9E0DgHxlQSAU8Ffg0VltpWFX7yhdcfV2829N0+GSf0qEQgEoEKgAgUQQAaBAiRABBaIV2NVyGiNQtExIAQWgABSAAlAACkABKAAFoAAUgAJQAApAASgABaAAFIACUAAKQAEoAAWgABSAAlAACkABKAAFoAAUgAJQAApoVOD/ARDZUhshEADIAAAAAElFTkSuQmCC"
                        />
                    </defs>
                </svg>

                <!-- <div class="truck-wrapper">
          <div class="truck">
            <div class="truck-container"></div>
            <div class="glases"></div>
            <div class="bonet"></div>

            <div class="base"></div>

            <div class="base-aux"></div>
            <div class="wheel-back"></div>
            <div class="wheel-front"></div>

            <div class="smoke"></div>
          </div>
        </div> -->
            </div>
        </div>
    </div>
</template>
<style scoped>
.pulse {
    animation: pulseAnim 2s infinite ease-in-out;
    transform-origin: center;
}

@keyframes pulseAnim {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.1);
        opacity: 0.7;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}
.preloader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    z-index: 9999;
    transition: opacity 0.5s ease-in-out;
}

.show-preloader {
    opacity: 1;
    visibility: visible;
}

.hide-preloader {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
}

.loader-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.diamond-logo {
    position: relative;
    width: 60px;
    height: 60px;
    animation: logoFade 2s ease-in-out infinite;
}

.diamond {
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: #1e40af;
    transform: rotate(45deg);
    border-radius: 2px;
}

.diamond-1 {
    top: 0;
    left: 20px;
    animation: diamond1 1.5s ease-in-out infinite;
}

.diamond-2 {
    top: 15px;
    left: 5px;
    background-color: #3b82f6;
    animation: diamond2 1.5s ease-in-out infinite 0.2s;
}

.diamond-3 {
    top: 15px;
    left: 35px;
    background-color: #3b82f6;
    animation: diamond3 1.5s ease-in-out infinite 0.4s;
}

@keyframes logoFade {
    0%,
    100% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.8;
        transform: scale(1.05);
    }
}

@keyframes diamond1 {
    0%,
    100% {
        transform: rotate(45deg) scale(1);
        opacity: 1;
    }
    50% {
        transform: rotate(45deg) scale(1.1);
        opacity: 0.9;
    }
}

@keyframes diamond2 {
    0%,
    100% {
        transform: rotate(45deg) scale(1);
        opacity: 0.9;
    }
    50% {
        transform: rotate(45deg) scale(1.1);
        opacity: 1;
    }
}

@keyframes diamond3 {
    0%,
    100% {
        transform: rotate(45deg) scale(1);
        opacity: 0.9;
    }
    50% {
        transform: rotate(45deg) scale(1.1);
        opacity: 1;
    }
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .diamond-logo {
        width: 50px;
        height: 50px;
    }

    .diamond {
        width: 16px;
        height: 16px;
    }

    .diamond-1 {
        left: 17px;
    }

    .diamond-2 {
        top: 12px;
        left: 4px;
    }

    .diamond-3 {
        top: 12px;
        left: 30px;
    }
}
</style>
